enum API {
	CLUBS = '/api/clubs',
	CLUBS_BY_ID = '/api/clubs/'
}

export default API;
